import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as listsActions from '../store/lists/actions';
import * as adsActions from '../store/ads/actions';
import * as reducers from '../store/reducers';

import ContentCollections from 'Containers/ContentCollections';
import GradeHeader from 'Components/GradeHeader';
import PlaygroundHeader from 'Components/PlaygroundHeader';
import RampUnit from '../utils/Playwire/RampUnit';
import Loading from 'Components/Loading';
import DocumentHeadFields from 'Components/DocumentHeadFields';
import ErrorPage from 'Screens/ErrorPage';
import PlaygroundCustomAd from 'Components/PlaygroundCustomAd';
import VideoSiderailPlayer from 'Components/VideoSiderailPlayer';

import { withLocationWrapper } from '../utils/HOC_LocationWrapper';

class GradeLandingPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pageLoading: true,
    };

    this.onPlaygroundAdLoad = this.onPlaygroundAdLoad.bind(this);
    this.onPlaygroundAdClick = this.onPlaygroundAdClick.bind(this);
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.fetchData();
      this.setState({
        pageLoading: true,
      });
    }
    if (!this.props.isFetching && this.state.pageLoading) {
      this.setState({
        pageLoading: false,
      });
    }
  }

  onPlaygroundAdLoad() {
    const { trackAdInternal, playgroundAdCampaign } = this.props;
    trackAdInternal('playground', 'PLAYGROUND_AD_VIEWED', playgroundAdCampaign);
  }

  onPlaygroundAdClick(eventId) {
    const { trackAdInternal, playgroundAdCampaign } = this.props;
    trackAdInternal('playground', eventId, playgroundAdCampaign);
  }

  fetchData() {
    const { fetchMediaLists, mediaType, grade } = this.props;
    const qs = { grade };
    fetchMediaLists(`gradeLanding`, location.pathname, qs);
  }

  render() {
    const {
      isFetching,
      errors,
      lists,
      hero,
      grade,
      playgroundAdCampaign,
    } = this.props;
    const { pageLoading } = this.state;

    if (errors.lists && !lists) {
      return (
        <ErrorPage
          errorCode="500"
          errorType="unknownError"
          errorMessage={errors.lists.message}
        />
      );
    }

    if (pageLoading) {
      return <Loading />;
    }

    const loadAds = !pageLoading;
    const titleGradeStr =
      grade <= 0 ? 'Pre-K and Kindergarten' : `Grade ${grade}`;
    const playgroundCampaignActive = playgroundAdCampaign && grade === 0;
    const customAdClass = playgroundCampaignActive
      ? ' Page__container--playground-ad'
      : '';

    const HeaderComponent = () =>
      grade === 0 ? (
        <PlaygroundHeader
          adCampaign={playgroundAdCampaign}
          onAdClick={() =>
            this.onPlaygroundAdClick('PLAYGROUND_AD_CHARACTER_CLICKED')
          }
        />
      ) : (
        <GradeHeader shouldLoad={loadAds} hero={hero} />
      );

    return (
      <main className="">
        <DocumentHeadFields
          documentTitle={`Games, Books, and Videos for Kids in ${titleGradeStr}`}
        />

        {!playgroundCampaignActive && (
          <div className="Page__container Page__container--no-padding">
            <RampUnit type="leaderboard_atf" id="top" />
          </div>
        )}

        <div className="Page__ContentWrapper">
          <div
            className={`Page__container Page__container--split-layout Page__container--main${customAdClass}`}
          >
            {playgroundCampaignActive && playgroundAdCampaign.customAd && (
              <PlaygroundCustomAd
                adCampaign={playgroundAdCampaign}
                onAdLoad={this.onPlaygroundAdLoad}
                onAdClick={() =>
                  this.onPlaygroundAdClick('PLAYGROUND_AD_CLICKED')
                }
              />
            )}

            <HeaderComponent />
            <aside className="ContentBlock__aside">
              {grade === 0 && <VideoSiderailPlayer />}
              <div>
                <RampUnit type="med_rect_atf" id="siderec" />
              </div>
              <RampUnit type="med_rect_btf" id="sideflex" />
            </aside>
            <section className="ContentBlock">
              <div className="ContentBlock__content">
                {!isFetching && <ContentCollections lists={lists} />}
              </div>
            </section>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state, { params, location }) => {
  const grade = params.grade ? params.grade : 0;
  return {
    grade,
    isFetching: reducers.getIsPageFetching(state),
    hero: reducers.getHero(state, location.pathname),
    playgroundAdCampaign: reducers.getAdCampaign(state, 'playground'),
    lists: reducers.getMediaLists(state, 'gradeLanding', location.pathname),
    errors: reducers.getErrors(state),
  };
};

const GradeLandingPageComponent = connect(mapStateToProps, { ...listsActions, ...adsActions })(GradeLandingPage);

export default withLocationWrapper(GradeLandingPageComponent);
